import ForgotPasswordForm from '../forms/ForgotPasswordForm';

const ReturningCustomerForgot = (props) => {
  const { redirectLink } = props;
  return (
    <div className="c7-account-login--returning-customer">
      <h4>Forgot Password</h4>
      <ForgotPasswordForm
        redirectLink={redirectLink}
        loginLink="/profile/login"
      />
    </div>
  );
};

export default ReturningCustomerForgot;
